/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ParentEnvironmentIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M4 10c0-2.187 1.75-4 4-4h24c2.188 0 4 1.813 4 4v4c0 2.25-1.812 4-4 4H13.5v6c0 1.438 1.063 2.5 2.5 2.5h2V26c0-2.187 1.75-4 4-4h10c2.188 0 4 1.813 4 4v4c0 2.25-1.812 4-4 4H22c-2.25 0-4-1.75-4-4v-.5h-2a5.47 5.47 0 0 1-5.5-5.5v-6H8c-2.25 0-4-1.75-4-4zm28 15H22c-.562 0-1 .5-1 1v4c0 .563.438 1 1 1h10c.5 0 1-.437 1-1v-4c0-.5-.5-1-1-1"/>}
        </IconWrapper>);
}
